/** API de dominio Commissions. Solo tipos y labels desde ./domain/**. */
export type {
  CommissionPlan,
  CommissionRule,
  CommissionAssignment,
  CommissionEarning,
  CommissionSummary,
  MyCommissionSummary,
  CommissionAdjustment,
  CommissionSettlement,
  SettlementDetail,
  CommissionRuleType,
  CommissionScope,
  CommissionBase,
  AttributionRole,
  AdjustmentType,
  PaymentMethod,
  SettlementStatus,
  EarningStatus,
  TierConfig,
} from './domain/commissionTypes';
export {
  RULE_TYPE_LABELS,
  SCOPE_LABELS,
  COMMISSION_BASE_LABELS,
  ATTRIBUTION_ROLE_LABELS,
  ADJUSTMENT_TYPE_LABELS,
  SETTLEMENT_STATUS_LABELS,
  SETTLEMENT_STATUS_COLORS,
  EARNING_STATUS_LABELS,
  PAYMENT_METHOD_LABELS,
  commissionEarningTitle,
} from './domain/commissionTypes';
